import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {observable, makeObservable} from 'mobx';

import {formUtilsService} from '../../core/services/form-utils.service';
import FormLabel from './form-label';

@observer
export default class TextInput extends React.Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.bool
    ]),
    onChange: PropTypes.func.isRequired,

    type: PropTypes.string,
    required: PropTypes.bool,
    charLimit: PropTypes.number,
    disabled: PropTypes.bool,
    labelText: PropTypes.string,
    helperText: PropTypes.string,
    labelTextIsSrOnly: PropTypes.bool,
    labelErrorIsSrOnly: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    showClearButton: PropTypes.bool,
    submitIcon: PropTypes.string,
    iconClass: PropTypes.string,
    onDropIntoList: PropTypes.func,
    disableAutoComplete: PropTypes.bool,
    announceError: PropTypes.bool,
    onClearClick: PropTypes.func,
    onSubmit: PropTypes.func
  }

  static defaultProps = {
    type: 'TEXT_STANDARD',
    labelText: '',
    helperText: '',
    labelTextIsSrOnly: false,
    labelErrorIsSrOnly: false,
    required: false,
    disabled: false,
    errorMessage: 'This entry is not valid.',
    className: '',
    showClearButton: false,
    disabledAutocomplete: false
  }

  @observable charLimitReached = false;
  @observable hasVisibleError = false;

  constructor(props) {
    super(props);
    makeObservable(this);
    this.addHttpToWebsites();
  }

  validate = () => {
    //delay until end of store update
    setTimeout(() => {
      this.hasVisibleError = formUtilsService.textInputIsInvalid(this.props.type, this.props.required, this.props.value);
    }, 0);
  }

  addHttpToWebsites = () => {
    if(this.props.type === 'TEXT_WEBSITE' && !(/^https?:\/\//).test(this.props.value)) { // FPSE-3149 - make sure links include http or https
      const newValue = `http://${this.props.value}`;
      this.props.onChange(this.props.id, newValue);
    }
  }

  onChange = (e) => {
    let newValue = e.target.value;
    if (this.props.charLimit) {
      newValue = newValue.substr(0, this.props.charLimit);
      this.charLimitReached = newValue.length >= this.props.charLimit;
    }

    const forceToType = this.props.type === 'TEXT_NUMERIC' ? 'number' : 'string';
    this.props.onChange(this.props.id, formUtilsService.cast(newValue, forceToType, 0));
    this.validate();
  }

  onBlur = () => {
    this.addHttpToWebsites();
    this.validate();
  }

  onKeyPress = (e) => {
    if (this.props.onSubmit && e.key == 'Enter') {
      e.preventDefault();
      this.props.onSubmit();
    }
  }

  onClearClick = () => {
    this.props.onChange(this.props.id, undefined);
    this.btnSubmit.focus();
    this.validate();
    if(this.props.onClearClick) {
      this.props.onClearClick();
    }
  }

  onSubmit = () => {
    this.input.blur();
    this.props.onSubmit();
  }

  focus = () => {
    this.input.focus();
  }

  scrollIntoView = (args) => {
    const element = document.getElementById(this.props.id);
    element.scrollIntoView(args);
  }

  render() {
    const Tag = this.props.charLimit > 170 ? 'textarea' : 'input';
    const trueType = this.props.type === 'TEXT_NUMERIC' ? 'number' : 'text';
    const clearButtonVisible = this.props.showClearButton && this.props.value !== '';
    const submitButtonVisible = this.props.onSubmit !== undefined;
    return (
      <div className={`form-group ${this.props.className} ${this.hasVisibleError ? 'has-error' : ''}`}>
        <FormLabel
          htmlFor={this.props.id}
          charLimitReached={this.charLimitReached}
          hasError={this.hasVisibleError}
          fieldIsRequired={this.props.required}
          labelText={this.props.labelText}
          labelTextIsSrOnly={this.props.labelTextIsSrOnly}
          labelErrorIsSrOnly={this.props.labelErrorIsSrOnly}
          helperText={this.props.helperText}
          errorMessage={this.props.errorMessage}
          announceError={this.props.announceError} />
        <div className={`input-group ${this.props.iconClass ? 'has-icon' : ''}`}>
          <Tag
            className="form-control"
            ref={(i) => {this.input = i}}
            id={this.props.id}
            type={trueType}
            disabled={this.props.disabled}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onKeyPress={this.onKeyPress}
            value={this.props.value}
            onKeyDown={this.props.onDropIntoList}
            autoComplete={this.props.disableAutoComplete ? 'off' : 'on'}/>
          {this.props.iconClass && <i className={`prefix-icon ${this.props.iconClass}`}></i>}
          {clearButtonVisible &&
            <span className="input-group-btn">
              <button
                ref={(i) => {this.btnClear = i }}
                className="clear-btn"
                type="button"
                onClick={this.onClearClick}>
                <span className="sr-only">Clear</span>
                <span aria-hidden="true" className="icon-close" />
              </button>
            </span>
          }
          {submitButtonVisible &&
            <span className="input-group-btn">
              <button className="submit-btn" type="button" ref={(i) => { this.btnSubmit = i }} onClick={this.onSubmit} disabled={this.props.disabled}>
                <span className="sr-only">{this.props.type === 'search' ? 'Search' : 'Submit'}</span>
                <span aria-hidden="true" className={this.props.type === 'search' ? 'icon-search' : 'icon-arrowRight'} />
              </button>
            </span>
          }
        </div>
      </div>
    )
  }
}
